<script>
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import TextInput from "../ui/TextInput.svelte";
    import TextArea from "../ui/TextArea.svelte";
    import Warning from "../ui/Warning.svelte";
    import DatetimePicker from "../datetimePicker/DatetimePicker.svelte";

    const dispatch = createEventDispatcher();

    export let credits;
    export let dealSettings;
    
    const minDate = new Date();
    const maxDate = new Date(minDate.getFullYear() + 1, minDate.getMonth(), 0, 23, 59);

    $: allowedMonth = checkDate(offer.show_from, credits, dealSettings);

    let offer = {
        delivery_type: "instant",
        show_for_days: 5
    };

    function confirm() {
        dispatch("add", offer);
        offer = {
            delivery_type: "instant",
            show_for_days: 5
        };
        open = false;
    }

    function cancel() {
        open = false;
    }

    function checkDate(_date, credits, dealSettings) {
        const date = _date ? new Date(_date) : new Date;
        const available = dealSettings.offers_per_month - credits.months[date.getMonth()].spent - credits.months[date.getMonth()].reserved;
        if (available + credits.extra.available > 0) {
            return true
        }
        return false
    }

    let open = false;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Angebot posten</DialogTitle>
        <DialogDescription class="dialog-description">
            Beantworte in der Nachricht die folgenden Fragen: <b>Was ist dein Angebot? Wann und wie lange gilt es?</b><br>
            Das Angebot geht <b>sofort oder zur eingestellten Stunde live</b> und wird den Nutzern für <b>bis zu 5 Tagen</b> in ihrem Feed angezeigt.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <TextArea
                label="Betreff"
                bind:value={offer.subject}
                maxlength={50}
                rows={1}
            />
            <TextArea
                label="Nachricht"
                bind:value={offer.message}
                maxlength={300}
            />
            <span>Anzeigen ab </span>
            <DatetimePicker bind:date={offer.show_from} min={minDate} max={maxDate} />
            <hr>
            <label>Anzeigen für 
                <select bind:value={offer.show_for_days}>
                    <option value={1}>1 Tag</option>
                    <option value={2}>2 Tage</option>
                    <option value={3}>3 Tage</option>
                    <option value={4}>4 Tage</option>
                    <option value={5}>5 Tage</option>
                </select>
            </label>

            {#if !allowedMonth}
                <Warning>Für den gewählten Monat ist bereits das Guthaben verbraucht oder verplant.</Warning>
            {/if}
            {#if !offer.subject || !offer.message}
                <Warning>Bitte gib einen Betreff und eine Nachricht ein.</Warning>
            {/if}
            
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary" disabled={!offer.subject || !offer.message || !allowedMonth}>
                    Posten
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd>